// Utilities for working with Services_plan data on the marketer panel
//
// computePlanFinalCost:
//   Calculates the final cost for a services subscription based on:
//     base plan cost + (wa_cost if is_wa) + (backup_cost if is_backup)
//   Then applies the plan-level discount:
//     - discount_perc takes priority if > 0 (percentage off subtotal)
//     - otherwise discount_cost is subtracted as a flat amount
//
// buildPlanExtraInfo:
//   Returns a short human-readable breakdown of the plan's extra costs and
//   discount (shown as helper text below the plan dropdown).

const toNum = (v) => {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
};

export const computePlanFinalCost = (plan, options = {}) => {
    if (!plan) return '';
    const { is_wa = false, is_backup = false } = options;
    const base = toNum(plan.cost);
    const wa = is_wa ? toNum(plan.wa_cost) : 0;
    const backup = is_backup ? toNum(plan.backup_cost) : 0;
    const subtotal = base + wa + backup;

    const perc = toNum(plan.discount_perc);
    const flat = toNum(plan.discount_cost);

    let discount = 0;
    if (perc > 0) {
        discount = subtotal * (perc / 100);
    } else if (flat > 0) {
        discount = flat;
    }

    const finalCost = Math.max(0, subtotal - discount);
    return finalCost.toFixed(2);
};

export const buildPlanExtraInfo = (plan, currentLanguage = 'ar') => {
    if (!plan) return '';
    const isAr = currentLanguage === 'ar';
    const parts = [];

    if (toNum(plan.cost) > 0) {
        parts.push(isAr ? `السعر: ${plan.cost} ₪` : `Cost: ${plan.cost} ₪`);
    }
    if (toNum(plan.wa_cost) > 0) {
        parts.push(isAr ? `واتساب: ${plan.wa_cost} ₪` : `WA: ${plan.wa_cost} ₪`);
    }
    if (toNum(plan.backup_cost) > 0) {
        parts.push(isAr ? `نسخ احتياطي: ${plan.backup_cost} ₪` : `Backup: ${plan.backup_cost} ₪`);
    }
    if (toNum(plan.discount_perc) > 0) {
        const label = plan.discount_name ? `${plan.discount_name} ` : '';
        parts.push(isAr ? `خصم ${label}${plan.discount_perc}%` : `Discount ${label}${plan.discount_perc}%`);
    } else if (toNum(plan.discount_cost) > 0) {
        const label = plan.discount_name ? `${plan.discount_name} ` : '';
        parts.push(isAr ? `خصم ${label}${plan.discount_cost} ₪` : `Discount ${label}${plan.discount_cost} ₪`);
    }

    return parts.join(' • ');
};

export const findPlanById = (plans, id) => {
    if (!id) return null;
    const numericId = parseInt(id);
    return (Array.isArray(plans) ? plans : []).find(p => p.id === numericId) || null;
};
